// extracted by mini-css-extract-plugin
module.exports =  {"bbTextDefaultFontSize":"2vw"};